import { render, staticRenderFns } from "./ClicButton.vue?vue&type=template&id=6068dd6a&"
import script from "./ClicButton.vue?vue&type=script&lang=js&"
export * from "./ClicButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports